import clsx from 'clsx';
import type { ReactElement } from 'react';

import type { FilterDropdownOption } from '@/components/FilterDropdown/FilterDropdown';
import FilterDropdown from '@/components/FilterDropdown/FilterDropdown';

export interface RarityFilterDropdownProps {
  selectedRarities: string[];
  onToggle: (rarity: string) => void;
  onClear: () => void;
  className?: string;
}

const RARITY_ICON_BASE_CLASS = 'ms ms-rarity ms-fw text-[14px]';

const RARITY_OPTIONS: FilterDropdownOption[] = [
  {
    value: 'common',
    label: 'Common',
    icon: <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-common!')} aria-hidden="true" />,
    badgeClassName: 'bg-r-common/15 text-r-common border border-r-common/25',
  },
  {
    value: 'uncommon',
    label: 'Uncommon',
    icon: <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-uncommon!')} aria-hidden="true" />,
    badgeClassName: 'bg-r-uncommon/20 text-r-uncommon border border-r-uncommon/30',
  },
  {
    value: 'rare',
    label: 'Rare',
    icon: <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-rare!')} aria-hidden="true" />,
    badgeClassName: 'bg-r-rare/20 text-r-rare border border-r-rare/30',
  },
  {
    value: 'mythic',
    label: 'Mythic',
    icon: <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-mythic!')} aria-hidden="true" />,
    badgeClassName: 'bg-r-mythic/20 text-r-mythic border border-r-mythic/30',
  },
  {
    value: 'other',
    label: 'Other',
    icon: <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-other!')} aria-hidden="true" />,
    badgeClassName: 'bg-r-other/20 text-r-other border border-r-other/30',
  },
];

const TRIGGER_ICON = <i className={clsx(RARITY_ICON_BASE_CLASS, 'text-r-rare!')} aria-hidden="true" />;

export default function RarityFilterDropdown({ selectedRarities, onToggle, onClear, className }: RarityFilterDropdownProps): ReactElement {
  return (
    <FilterDropdown
      triggerLabel="Rarity"
      triggerIcon={TRIGGER_ICON}
      options={RARITY_OPTIONS}
      selectedValues={selectedRarities}
      onToggle={onToggle}
      onClear={onClear}
      searchPlaceholder="Search rarities..."
      ariaLabel="Rarity filter"
      className={className}
      maxTriggerIcons={4}
    />
  );
}
